import { combineReducers } from 'redux';
import oohSegmentsReducer from './oohSegements/oohSegments.reducer';

const customAudienceReducer = combineReducers({
  oohSegments: oohSegmentsReducer,
});

export default customAudienceReducer;
